<template lang="pug" src="./custom-home-follow.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  data () {
    return {
      height: 200,
      current: 3,
      user: 'Hopkeortho'
    }
  },
  computed: {
    instagram () {
      return this.$store.state.instagram
    },
    email () {
      let subject = this.props.email_subject_line
      let body = this.props.email_body

      return `mailto:info@hopkeortho.com?subject=${subject}&body=${body}`
    }
  },
  async mounted () {
    this.height = this.$refs.image[0].offsetWidth
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-home-follow/custom-home-follow.vue